import "./Implants.module.css";
import Header from "../../reusable_sections/Header";
import Footer from "../../reusable_sections/Footer";
import KeyBenefits from "./sections/KeyBenefits";
import Faq from "./sections/Faq";
import SitemapInput from "./sections/SitemapInput";
export default function ImplantsPage() {
  return <div>
      <Header />
      <KeyBenefits />
      <Faq />
      <SitemapInput />
      <Footer />
    </div>;
}